import { render, staticRenderFns } from "./CompanyConversion.vue?vue&type=template&id=b886c38a&scoped=true&"
import script from "./CompanyConversion.vue?vue&type=script&lang=js&"
export * from "./CompanyConversion.vue?vue&type=script&lang=js&"
import style0 from "./CompanyConversion.vue?vue&type=style&index=0&id=b886c38a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b886c38a",
  null
  
)

export default component.exports